export const modal = {
  modifyTitle: "MODIFIER LA RÉSERVATION",
  createTitle: "CRÉER UNE RÉSERVATION",
  modifyAction: "Modifier la réservation",
  createAction: "Créer la réservation",
  processing: "Traitement de la réservation...",

  selectRoomType: "Sélectionnez un type de chambre",
  selectAccommodation: "Sélectionnez un hébergement",

  quantity: "Quantité",
  arrival: "Arrivée",
  departure: "Départ",
  guestName: "Nom du client",
  email: "E-mail",
  phone: "Téléphone",
  guestsNumber: "Nombre de personnes",
  price: "Prix",
  cancel: "Annuler",

  noTemplateSummary: "Aucun modèle actif",
  noTemplateDetail: "Aucun modèle disponible",

  limitReachedSummary: "Limite atteinte",
  limitPromotionDetail: "Vous ne pouvez pas ajouter plus de 1 promotion",
  limitTaxDetail: "Vous ne pouvez pas ajouter plus de 1 taxe",

  validations: {
    fillRequired: "Veuillez remplir tous les champs obligatoires.",
    phoneMin: "Le numéro de téléphone doit comporter au moins 5 chiffres.",
    selectDates: "Veuillez sélectionner les dates d'arrivée et de départ.",
    guestsMin: "Le nombre de personnes doit être d'au moins 1.",
    priceNegative: "Le prix ne peut pas être négatif.",
  },
};

export default modal;
